import {
  Show,
  TextField,
  DateField,
  NumberField,
  ReferenceManyField,
  Datagrid,
  TabbedShowLayout,
} from 'react-admin';
import { Box } from '@mui/material';
import { AddUserToGroupButton } from './AddUserToGroupButton';
import { RemoveUserFromGroupButton } from './RemoveUserFromGroupButton';
import { GroupMachinesList } from './GroupMachinesList';

export const GroupShow = () => (
  <Show>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Summary">
        <NumberField source="id" />
        <TextField source="name" />
        <DateField source="createdAt" showTime />
        <DateField source="updatedAt" showTime />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Users" path="users">
        <ReferenceManyField reference="users" target="groupId" label={false}>
          <Datagrid
            bulkActionButtons={false}
            rowClick="show"
            sx={{
              '& .column-id': { textAlign: 'left' },
              '& .column-id th': { textAlign: 'left' },
            }}
          >
            <NumberField source="id" textAlign="left" />
            <TextField source="username" />
            <TextField source="role" />
            <DateField source="createdAt" showTime />
            <RemoveUserFromGroupButton />
          </Datagrid>
        </ReferenceManyField>
        <Box sx={{ mt: 1, mb: 1, textAlign: 'right' }}>
          <AddUserToGroupButton />
        </Box>
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Machines" path="machines">
        <GroupMachinesList />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
